import React from "react"

export function ImageIcon() {
    return (
        <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
            <g id="Page-1" stroke="none" strokeWidth="1" fillRule="evenodd">
                <g id="2.signature-copy" transform="translate(-38.000000, -252.000000)">
                    <g id="noun_332296_cc-copy-2" transform="translate(38.000000, 252.000000)">
                        <g id="Group">
                            <g>
                                <path
                                    d="M22.8,0 L1.2,0 C0.48,0 0,0.48 0,1.2 L0,22.8 C0,23.52 0.48,24 1.2,24 L22.8,24 C23.52,24 24,23.52 24,22.8 L24,1.2 C24,0.48 23.52,0 22.8,0 L22.8,0 Z M21.6,2.4 L21.6,18.84 L16.8,14.4 L12,19.2 L7.2,10.8 L2.4,18.48 L2.4,2.4 L21.6,2.4 L21.6,2.4 Z"
                                    id="Shape"
                                ></path>
                                <circle id="Oval" cx="13.8" cy="7.8" r="1.8"></circle>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    )
}
